import React from "react";

import { Stack } from "@mui/material";
import { useAccountSelector } from "store";

import { ICreateInvestorData, IUseFormikHandleChange } from "../../../../store/types";
import { Button, TextInputFormik } from "../../../forms";

interface IInvestorsFormProps {
  onCancel: (value: boolean) => void;
  addInvestorError: any;
  handleSubmit: Function;
  values: ICreateInvestorData;
  handleChange: IUseFormikHandleChange;
}

export const InvestorsForm: React.FC<IInvestorsFormProps> = ({
  onCancel,
  addInvestorError,
  handleSubmit,
  handleChange,
  values
}) => {
  const { support_investor_groups } = useAccountSelector() || {};
  return (
    <Stack direction="column">
      <Stack direction="column" sx={{ flexGrow: 1, fontWeight: 500 }}>
        <Stack direction="column" gap="20px">
          <TextInputFormik
            label="Investor Name"
            name="name"
            required={true}
            placeholder="Investor Name"
            errors={addInvestorError?.name}
            onChange={handleChange}
          />
          {support_investor_groups && (
            <TextInputFormik
              label="Investor Group"
              name="group"
              placeholder="Investor Group"
              errors={addInvestorError?.group}
              onChange={handleChange}
            />
          )}
          <TextInputFormik
            label="Email Address"
            name="email"
            placeholder="Email Address"
            errors={addInvestorError?.email}
            onChange={handleChange}
          />
          <TextInputFormik
            label="Phone Number"
            name="phone_number"
            placeholder="Phone Number"
            errors={addInvestorError?.phone_number}
            onKeyPress={(e) => {
              const char = e.key;
              if (!/[\d+-]/.test(char)) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              const formattedValue = value.replace(/[^\d+-]/g, "");
              handleChange(formattedValue);
            }}
          />
          <TextInputFormik
            label="Company"
            name="company"
            placeholder="Company"
            onChange={handleChange}
            errors={addInvestorError?.company}
          />
          <TextInputFormik
            label="Additional Information"
            name="additional_information"
            placeholder="Additional Information"
            onChange={handleChange}
            errors={addInvestorError?.additional_information}
          />
          <TextInputFormik
            label="Alias"
            name="description"
            placeholder="Alias"
            onChange={handleChange}
            errors={addInvestorError?.description}
          />
          <Stack direction="row" gap="10px" justifyContent="flex-end">
            <Button
              dataTestId="create-deal-general-cancel"
              variant="light"
              title="Cancel"
              onClick={() => onCancel(false)}
            />
            <Button
              dataTestId="create-deal-general-next"
              title="Add Investor"
              onClick={() => {
                handleSubmit(values);
              }}
              disabled={
                !values.name &&
                !values.email &&
                !values.phone_number &&
                !values.company &&
                !values.additional_information
              }
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
